import { useState } from 'react';
import { Delete } from 'lucide-react';

/**
 * Tastierino numerico con dots. Chiama onComplete quando si raggiunge `length`.
 * Il parent resetta lo stato cambiando la `key` del componente tra i passi.
 */
export function PinPad({
  length = 6,
  onComplete,
  error,
}: {
  length?: number;
  onComplete: (pin: string) => void;
  error?: string | null;
}) {
  const [pin, setPin] = useState('');

  const push = (d: string) => {
    if (pin.length >= length) return;
    const next = pin + d;
    setPin(next);
    if (next.length === length) onComplete(next);
  };
  const back = () => setPin((p) => p.slice(0, -1));

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 22 }}>
      <div className="lockscreen__pin">
        {Array.from({ length }).map((_, i) => (
          <span key={i} className={i < pin.length ? 'is-filled' : ''} />
        ))}
      </div>
      {error && <div style={{ color: 'var(--adim)', fontSize: 13 }}>{error}</div>}
      <div className="keypad">
        {['1', '2', '3', '4', '5', '6', '7', '8', '9'].map((d) => (
          <button key={d} type="button" onClick={() => push(d)}>
            {d}
          </button>
        ))}
        <span className="keypad__blank" />
        <button type="button" onClick={() => push('0')}>
          0
        </button>
        <button type="button" className="keypad__blank" onClick={back} aria-label="Cancella">
          <Delete size={22} style={{ color: 'var(--muted)' }} />
        </button>
      </div>
    </div>
  );
}
